const consultationsActionTypes = {
  addConsultation: 'consultations/addConsultation',
};

export default consultationsActionTypes;
